module.exports = __webpack_public_path__ + "img/turkey-violence.52f42281.jpg";